module.exports = __webpack_public_path__ + "static/media/iconos.0b38f6c5.png";